import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { useAuthContext } from "contexts/AuthContext";

// core components
import { Col, Container, Row } from "stories/layout"
import { useNotification } from "stories/components/Notification"

// Import the new form component
import PasswordForgotForm from "components/Forms/PasswordForgotForm/PasswordForgotForm";

const PasswordForgotView = ({match, history}) => {
  const { t } = useTranslation();
  const { notify } = useNotification();
  const [infoAlert, setInfoAlert] = useState();
  const { getCurrentLanguage } = useAuthContext(); 
  
  const handleModalConfirm = () => {
    setInfoAlert(null);
    history.push("/dashboard/users");
  }
  
  const handleResolve = () => {
    notify({ title:t("User","Käyttäjä"), message:t("password_forgot_sent_ok","Salasanan palautuslinkki on lähetetty sähköpostiisi")})
    handleModalConfirm();
  }
  
  return (
    <>
      <Container className="mt-4 pb-5">
        <Row className="justify-content-center">
          <Col lg="6" md="7" className="">
            <PasswordForgotForm 
              history={history} 
              t={t} 
              handleResolve={handleResolve} 
              notify={notify} 
            />
          </Col>
        </Row>
      </Container>
      {infoAlert}
    </>
  )
}

export default PasswordForgotView;
